import styled from '@emotion/styled';
import field from 'ud-ui/components/icon/icons/soccer-field.svg';

const Background = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${field});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.4;
  pointer-events: none;
  z-index: 0;
`;

const FieldBackground = () => <Background />;

export default FieldBackground;
